import Vue from 'vue';
import EmailSendFile from '@/components/EmailSendFile';

let EmailSendFileBox = Vue.extend(EmailSendFile);

EmailSendFile.install = (options) => {
    let instance = new EmailSendFileBox({
        data: options
    }).$mount();
    document.body.appendChild(instance.$el);
    return instance.confirm();
};
export default EmailSendFile;
